import { WEB_ASSETS, notificationCountIconKey } from '@tenfour/contracts'
import s from './ClayPunctuation.module.css'

type ResponsiveAsset = {
  readonly oneX: string
  readonly twoX: string
}

type MarkSize = 'xs' | 'sm' | 'md' | 'lg'

function ResponsiveClayImage({
  asset,
  className,
}: {
  asset: ResponsiveAsset
  className?: string
}) {
  return (
    <img
      src={asset.oneX}
      srcSet={`${asset.oneX} 1x, ${asset.twoX} 2x`}
      width={64}
      height={64}
      alt=""
      className={`${s.image} ${className ?? ''}`.trim()}
      decoding="async"
      aria-hidden="true"
      draggable={false}
    />
  )
}

export function ClayEllipsis({
  orientation = 'horizontal',
  size = 'md',
  className,
}: {
  orientation?: 'horizontal' | 'vertical'
  size?: MarkSize
  className?: string
}) {
  return (
    <span
      className={`${s.mark} ${s[size]} ${className ?? ''}`.trim()}
      aria-hidden="true"
    >
      <ResponsiveClayImage
        asset={WEB_ASSETS.icons.punctuation.ellipsis}
        className={orientation === 'vertical' ? s.vertical : undefined}
      />
    </span>
  )
}

export function ClayDot({
  label,
  size = 'xs',
  className,
}: {
  label: string
  size?: MarkSize
  className?: string
}) {
  return (
    <span
      className={`${s.mark} ${s[size]} ${className ?? ''}`.trim()}
      role="img"
      aria-label={label}
      title={label}
    >
      <ResponsiveClayImage asset={WEB_ASSETS.icons.punctuation.dot} />
    </span>
  )
}

export function ClayCountBadge({
  count,
  label,
  size = 'md',
  className,
}: {
  count: number
  label: string
  size?: 'sm' | 'md'
  className?: string
}) {
  const asset = WEB_ASSETS.icons.punctuation.counts[notificationCountIconKey(count)]

  return (
    <span
      className={`${s.count} ${s[`count_${size}`]} ${className ?? ''}`.trim()}
      role="img"
      aria-label={label}
      title={label}
    >
      <ResponsiveClayImage asset={asset} />
    </span>
  )
}

export function ClayBell({
  size = 'lg',
  className,
}: {
  size?: MarkSize
  className?: string
}) {
  return (
    <span className={`${s.mark} ${s[size]} ${className ?? ''}`.trim()} aria-hidden="true">
      <ResponsiveClayImage asset={WEB_ASSETS.icons.punctuation.bell} />
    </span>
  )
}
